export const demoExercises = [
    {
        Name: "Open Mouth",
        ExerciseType: "Unilateral",
      },
      {
        Name: "Blink",
        ExerciseType: "Bilateral",
      },
      {
        Name: "Smile",
        ExerciseType: "Bilateral",
      },
];